import React from 'react'
import { CardCVCElement, CardExpiryElement, CardNumberElement } from 'react-stripe-elements'
import { Col, Grid, Row } from 'react-flexbox-grid'
import injectSheet from 'react-jss'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

const stripeStyle = {
  base: {
    fontSize: '16px',
    color: '#32325d',
  },
}

const styles = () => {
  return {
    '@global': {
      '.StripeElement': {
        backgroundColor: 'white',
        padding: '10px 12px',
        borderRadius: '20px',
        border: '1px solid transparent',
        boxShadow: '0 3px 3px #D2D2D2',
        WebkitTransition: 'box-shadow 150ms ease',
        transition: 'box-shadow 150ms ease',
      },
      '.StripeElement__focus': {
        boxShadow: '0 1px 3px 0 #cfd7df',
      },
      '.StripeElement__invalid': {
        borderColor: '#fa755a',
      },
      '.StripeElement__webkit_autofill': {
        backgroundColor: '#fefde5 !important',
      },
    },
    formRow: {
      paddingTop: '10px',
      paddingBottom: '10px',
    },
  }
}

@withTranslation()
@injectSheet(styles)
class CardInput extends React.Component {
  state = { mounted: false }

  handleCardNumberChange = (event) => {
    const { onCardNumberChange } = this.props
    if (onCardNumberChange) {
      onCardNumberChange(event)
    }
  }

  componentDidMount() {
    this.setState({ mounted: true })
    console.log('mount')
  }

  shouldComponentUpdate() {
    return false
  }

  componentWillUnmount() {
    console.log('umount')
  }

  render() {
    const { classes, t } = this.props
    // if (!mounted) {
    //   return null;
    // }
    // console.log('render');
    return (
      <Grid fluid>
        <Row className={classes.formRow}>
          <Col xs={12}>
            <label>
              {t('credit_card_number')}
              <CardNumberElement
                onReady={(el) => {
                  return el.focus()
                }}
                onChange={this.handleCardNumberChange}
                style={stripeStyle}
              />
            </label>
          </Col>
        </Row>
        <Row className={classes.formRow}>
          <Col xs={6}>
            <label>
              {t('expiry_date')}
              <CardExpiryElement style={stripeStyle} />
            </label>
          </Col>
          <Col xs={6}>
            <label>
              {t('cvv')}
              <CardCVCElement style={stripeStyle} />
            </label>
          </Col>
        </Row>
      </Grid>
    )
  }
}

CardInput.propTypes = {
  classes: PropTypes.object,
  onCardNumberChange: PropTypes.func,
  t: PropTypes.func,
}

export default CardInput
